import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, } from "@angular/core";
import { Observable, combineLatest, Subject } from "rxjs";
import { Select, Store } from "@ngxs/store";
import { ToggleTab, GetProductDetails, OnChangeVariantForm, ClearProductDetailsState, GetAccess, SelectProductVariant, GetRelatedProducts, UpdateProductDetails, GetProductRelatedBundles, GetIncludedProducts, SetIncludedProductsPagination, OnChangeBundleVariantForm, SetProductRelatedBundlesPagination, } from "../../actions/product-details.actions";
import { ActivatedRoute, Router } from "@angular/router";
import { map, filter, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { BREADCRUMBS_CONFIGURATION } from "src/app/core/configurations/breadcrumbs.config";
import { ProductDetailsService } from "../../services/product-details.service";
import { differenceInDays } from "date-fns";
import { AuthTokenState } from "../../../auth/state/auth-token.state";
import { AddLineItemToShoppingCart } from "../../../shopping-cart/actions/shopping-cart.actions";
import { BreadcrumbsBuildingService } from "src/app/core/services/breadcrumbs-building.service";
const ɵ0 = (state) => state.core.profile, ɵ1 = (state) => state.session.userDetails, ɵ2 = (state) => state.productDetails.details, ɵ3 = (state) => state.productDetails.selectedVariant, ɵ4 = (state) => state.productDetails.relatedBundles, ɵ5 = (state) => state.productDetails.relatedBundlesPagination, ɵ6 = (state) => state.productDetails.relatedBundlesTotalCount, ɵ7 = (state) => state.productDetails.includedProducts, ɵ8 = (state) => state.productDetails.includedProductsPagination, ɵ9 = (state) => state.productDetails.includedProductsTotalCount, ɵ10 = (state) => state.productDetails.productVariantDeliverables, ɵ11 = (state) => state.productDetails.productVariantDeliverablesPending, ɵ12 = (state) => state.productDetails.languages, ɵ13 = (state) => state.productDetails.deliveryFormats, ɵ14 = (state) => state.productDetails.certificateTypes, ɵ15 = (state) => state.productDetails.courseDeliveryFormats, ɵ16 = (state) => state.productDetails.variantForm, ɵ17 = (state) => state.productDetails.licenseForm, ɵ18 = (state) => state.productDetails.tab, ɵ19 = (state) => state.productDetails.expiringContract, ɵ20 = (state) => state.productDetails.getProductDetailsPending, ɵ21 = (state) => state.productDetails.getProductDetailsSuccess, ɵ22 = (state) => state.productDetails.segmentsMapper, ɵ23 = (state) => state.productDetails.requestEvaluationCopyPending, ɵ24 = (state) => state.productDetails.relatedProducts, ɵ25 = (state) => state.core.dictionaries.currencySignsMap, ɵ26 = (state) => state.core.dictionaries.dictionaryFetchingPending, ɵ27 = (state) => state.shoppingCart.addLineItemSku, ɵ28 = (state) => state.shoppingCart.addLineItemPending;
export class ProductDetailsComponent {
    constructor(productDetailsService, store, router, route, breadcrumbsBuildingService) {
        this.productDetailsService = productDetailsService;
        this.store = store;
        this.router = router;
        this.route = route;
        this.breadcrumbsBuildingService = breadcrumbsBuildingService;
        this.breadcrumbs = this.breadcrumbsBuildingService.buildBreadcrumbsWithQueryParams([
            BREADCRUMBS_CONFIGURATION.Products,
            BREADCRUMBS_CONFIGURATION.ProductDetails,
        ]);
        this.tabs = [];
        this.ngUnsubscribe = new Subject();
    }
    ngOnInit() {
        this.subscribeToProductDetails();
        this.route.paramMap.pipe(map((_) => _.get("sku"))).subscribe((sku) => {
            this.store.dispatch([
                new ClearProductDetailsState(),
                new GetProductDetails(sku),
            ]);
        });
        this.route.queryParamMap.subscribe((param) => {
            this.store.dispatch(new SelectProductVariant(param.get("language"), param.get("deliveryFormat"), param.get("certificateType"), param.get("license")));
        });
        const model = this.variantForm$.pipe(map((_) => _.model), filter((_) => !!_));
        const languageObservable$ = model.pipe(map((_) => _.language), distinctUntilChanged());
        const deliveryFormatObservable$ = model.pipe(map((_) => _.deliveryFormat), distinctUntilChanged());
        const certificateTypeObservable$ = model.pipe(map((_) => _.certificateType), distinctUntilChanged());
        combineLatest(languageObservable$, deliveryFormatObservable$, certificateTypeObservable$).subscribe((_) => {
            this.store.dispatch(new OnChangeVariantForm());
        });
        this.licenseForm$
            .pipe(takeUntil(this.ngUnsubscribe), filter((licenseForm) => licenseForm && !!licenseForm.model), map((licenseForm) => licenseForm.model))
            .subscribe(() => this.store.dispatch(new OnChangeBundleVariantForm()));
    }
    subscribeToProductDetails() {
        combineLatest(this.product$, this.selectedVariant$, this.expiringContract$)
            .pipe(filter((_) => _ && _.length && !!_[0] && !!_[1]), takeUntil(this.ngUnsubscribe))
            .subscribe(([productDetails, selectedVariant, expiringContract]) => {
            if (productDetails) {
                this.videoAboutProduct = productDetails.videos.find((v) => v.featured);
                this.isProductBundle =
                    productDetails.typeConfig &&
                        productDetails.typeConfig.configKey === "bundle-product";
                this.initiateTabs(productDetails, selectedVariant, expiringContract);
                this.store.dispatch(new GetRelatedProducts(productDetails.sku));
            }
        });
        combineLatest([this.includedProductsPagination$, this.product$])
            .pipe(filter(([pagination, product]) => !!(product && product.bundle && product.bundle.sku)), takeUntil(this.ngUnsubscribe))
            .subscribe(([pagination, product]) => {
            this.store.dispatch(new GetIncludedProducts(product.bundle.sku, pagination));
        });
        combineLatest([this.relatedBundlesPagination$, this.product$])
            .pipe(filter(([pagination, product]) => !!product), takeUntil(this.ngUnsubscribe))
            .subscribe(([pagination, product]) => {
            this.store.dispatch(new GetProductRelatedBundles(product.sku, pagination));
        });
    }
    initiateTabs(productDetails, selectedVariant, expiringContract) {
        const tabs = [];
        tabs.push({ value: "about", displayValue: "About" });
        if (!this.isProductExam(productDetails) &&
            this.productDetailsService.isCourseInformationAvailable(productDetails)) {
            tabs.push({
                value: "course-information",
                displayValue: "Course Information",
            });
        }
        if (!this.isProductExam(productDetails) && !this.isProductBundle) {
            tabs.push({ value: "content", displayValue: "Content" });
        }
        if (this.isProductBundle) {
            tabs.push({ value: "products", displayValue: "Products" });
        }
        const expiryDate = expiringContract && expiringContract.expiryDate;
        if ((productDetails.restriction &&
            productDetails.restriction.restricted &&
            !productDetails.restriction.hasAccess) ||
            (expiryDate &&
                differenceInDays(new Date(expiryDate * 1000), new Date()) <= 28)) {
            tabs.push({ value: "how-to-access", displayValue: "How To Access" });
        }
        tabs.push({
            value: "delivery-and-specifications",
            displayValue: "Specifications",
        });
        tabs.push({ value: "media", displayValue: "Media" });
        tabs.push({ value: "reviews", displayValue: "Reviews" });
        tabs.push({ value: "bundles", displayValue: "Bundles" });
        this.tabs = tabs;
    }
    isTabSelected(selectedTab) {
        return this.tabs.findIndex((_) => _.value === selectedTab);
    }
    toggleTab(key) {
        this.store.dispatch([new ToggleTab(key)]);
    }
    isProductExam(product) {
        return product.type === "Exam";
    }
    addRelatedProductToCart(sku) {
        this.store.dispatch(new AddLineItemToShoppingCart(sku, 1));
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        this.store.dispatch(new ClearProductDetailsState());
    }
    getAccess(segment) {
        this.store.dispatch(new GetAccess(segment));
    }
    updateProductDetails(product) {
        this.store.dispatch(new UpdateProductDetails(product));
    }
    includedProductsPageChanged(pagination) {
        this.store.dispatch(new SetIncludedProductsPagination(pagination));
    }
    relatedBundlesPageChanged(pagination) {
        this.store.dispatch(new SetProductRelatedBundlesPagination(pagination));
    }
}
tslib_1.__decorate([
    Select(ɵ0),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "profile$", void 0);
tslib_1.__decorate([
    Select(ɵ1),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "userDetails$", void 0);
tslib_1.__decorate([
    Select(ɵ2),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "product$", void 0);
tslib_1.__decorate([
    Select(ɵ3),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "selectedVariant$", void 0);
tslib_1.__decorate([
    Select(ɵ4),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "relatedBundles$", void 0);
tslib_1.__decorate([
    Select(ɵ5),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "relatedBundlesPagination$", void 0);
tslib_1.__decorate([
    Select(ɵ6),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "relatedBundlesTotalCount$", void 0);
tslib_1.__decorate([
    Select(ɵ7),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "includedProducts$", void 0);
tslib_1.__decorate([
    Select(ɵ8),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "includedProductsPagination$", void 0);
tslib_1.__decorate([
    Select(ɵ9),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "includedProductsTotalCount$", void 0);
tslib_1.__decorate([
    Select(ɵ10),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "productVariantDeliverables$", void 0);
tslib_1.__decorate([
    Select(ɵ11),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "productVariantDeliverablesPending$", void 0);
tslib_1.__decorate([
    Select(ɵ12),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "languages$", void 0);
tslib_1.__decorate([
    Select(ɵ13),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "deliveryFormats$", void 0);
tslib_1.__decorate([
    Select(ɵ14),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "certificateTypes$", void 0);
tslib_1.__decorate([
    Select(ɵ15),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "courseDeliveryFormats$", void 0);
tslib_1.__decorate([
    Select(ɵ16),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "variantForm$", void 0);
tslib_1.__decorate([
    Select(ɵ17),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "licenseForm$", void 0);
tslib_1.__decorate([
    Select(ɵ18),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "selectedTab$", void 0);
tslib_1.__decorate([
    Select(ɵ19),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "expiringContract$", void 0);
tslib_1.__decorate([
    Select(ɵ20),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "getProductDetailsPending$", void 0);
tslib_1.__decorate([
    Select(ɵ21),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "getProductDetailsSuccess$", void 0);
tslib_1.__decorate([
    Select(ɵ22),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "segmentsMapper$", void 0);
tslib_1.__decorate([
    Select(ɵ23),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "requestEvaluationCopyPending$", void 0);
tslib_1.__decorate([
    Select(ɵ24),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "relatedProducts$", void 0);
tslib_1.__decorate([
    Select(ɵ25),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "currencySignsMap$", void 0);
tslib_1.__decorate([
    Select(ɵ26),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "dictionaryFetchingPending$", void 0);
tslib_1.__decorate([
    Select(ɵ27),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "addLineItemSku$", void 0);
tslib_1.__decorate([
    Select(ɵ28),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "addLineItemPending$", void 0);
tslib_1.__decorate([
    Select(AuthTokenState.isLogged),
    tslib_1.__metadata("design:type", Observable)
], ProductDetailsComponent.prototype, "isLogged$", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28 };
